export default __webpack_public_path__ + "static/mini-helix-bq-3-84b4515486805794e30d5e885e05301b.jpg";